import React from 'react';

import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import TextField from 'material-ui/TextField';
import CircularProgress from '@material-ui/core/CircularProgress';
import RaisedButton from 'material-ui/RaisedButton';

import urlBase from '../../../url-base';
import axios from 'axios';


class FormsOfReceiptsForm extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      id: '',
      paypalId: '',
      pagSeguroToken: '',
      pagSeguroEmail: '',

      loadingSave: false,
      success: null,
      validCpf: false,
      loadingCpf: false,

      emailError: {
        display: 'none',
        msg: ''
      }
    };

    this.styles = {
      sendFormSuccess: {
        padding: 10,
        color: '#155724',
        backgroundColor: '#d4edda',
        borderColor: '#c3e6cb'
      },
      sendFormError: {
        padding: 10,
        color: '#721c24',
        backgroundColor: '#f8d7da',
        borderColor: '#f5c6cb'
      },
      h3Title: {
        color: '#606060',
        marginTop: 20
      }
    };

    this.errorFormat = {
      pagSeguroEmail: ''
    };
  }


  componentDidMount() {
    
  }

  // Monitora mudanças a atualiza estados dos inputs text
  onChange(e) {
    let state = this.state;
    state[e.target.name] = e.target.value;
    state.success = null;
    this.setState(state);
  }

  onBlurField(e) {
    let state = this.state;
    state.emailError.display = 'none';
    state.emailError.msg = '';
    this.setState(state);

    if (e.target.type == 'email') {
      if (!e.target.validity.valid)
        this.errorFormat[e.target.name] = 'Formato esperado: email@exemplo.com';
      else {
        this.errorFormat[e.target.name] = '';
      }
    }
    else if (e.target.name == 'cpf')
      this.validateCpf(e.target.value);
  }

  checkPagSeguroEmail() {
    // Se o campo email pagseguro estiver preenchido
    if (this.state.pagSeguroEmail.length > 0) {
      // Se o campo email pagseguro não conter erro
      if (this.errorFormat.pagSeguroEmail.length == 0)
        this.onSubmitForm();
    }
    else
      this.onSubmitForm();
  }

  onSubmitForm() {
    let state = this.state;
    state.loadingSave = true;
    this.setState(state);
    document.getElementById('i_loading_send_salesman').scrollIntoView();

    // Pega o vendedor
    axios.get(urlBase.loopBack + 'Salesmans?filter={"where":{"userId":"'+localStorage.getItem('dental_u')+'"}}')
    .then((response) => {
      if (response.data.length > 0) {
        let dataSubmit = {
          id: response.data[0].id
        };

        if (this.state.paypalId.length > 0)
          dataSubmit.paypalId = this.state.paypalId;
        if (this.state.pagSeguroToken.length > 0)
          dataSubmit.pagSeguroToken = this.state.pagSeguroToken;
        if (this.state.pagSeguroEmail.length > 0)
          dataSubmit.pagSeguroEmail = this.state.pagSeguroEmail;

        axios.post(urlBase.loopBack + 'Salesmans/upsertWithWhere?where={"id":"'+response.data[0].id+'"}', dataSubmit)
        .then(() => {
          let state = this.state;
          state.loadingSave = false;
          state.success = true;
          this.setState(state);
          document.getElementById('i_loading_send_salesman').scrollIntoView();
          this.stateDefault();
        })
        .catch(() => {
          let state = this.state;
          state.loadingSave = false;
          state.success == false;
          this.setState(state);
          document.getElementById('i_loading_send_salesman').scrollIntoView();
        });
      }
      else
        alert('Vendedor não encontrado, entre em contado com a dental center através do número (83) 3041-4646');
    })
    .catch((error) => {
      alert('Erro ao buscar Vendedor:'+error);
    });
  }

  stateDefault() {
    let state = this.state;
    state.paypalId = '',
    state.pagSeguroToken = '',
    state.pagSeguroEmail = '',
    state.loadingSave = false,
    state.emailError = {
      display: 'none',
      msg: ''
    };

    this.setState(state);
  }


  render() {
    return (
      <div>
        <Paper id="i_loading_send_salesman" style={{padding: 10}}>
          {/* Mensagem de retorno do formulário */
            this.state.success != null ? (
              this.state.success == true ? (/* Formulário salvo com sucesso */
          <Grid container spacing={24} style={{marginTop:30}}>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <div style={{textAlign: 'center'}}>
                <p style={this.styles.sendFormSuccess}>Salvo com sucesso</p>
              </div>
            </Grid>
          </Grid>
              ) : (/* Erro ao enviar formulário */
          <Grid container spacing={24} style={{marginTop:30}}>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <div style={{textAlign: 'center'}}>
                <p style={this.styles.sendFormError}>Erro ao salvar formas de recebimentos</p>
              </div>
            </Grid>
          </Grid>
              )
            ) : ('')
          }


          {/* Loading de salvar o formulário */
            this.state.loadingSave == true ? (
          <Grid container spacing={24} style={{marginTop:30}}>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <div style={{textAlign: 'center'}}>
                <CircularProgress />
                <p>Enviando...</p>
              </div>
            </Grid>
          </Grid>
            ) : ('')
          }

          <div>

            <Grid container spacing={24}>
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <h3 style={this.styles.h3Title}>PayPal</h3>
              </Grid>

              <Grid item xs={12} sm={12} md={4} lg={4}>
                <TextField
                  style={this.styles.inputs}
                  hintText="ID Paypal"
                  floatingLabelText="ID Paypal"
                  type="text"
                  name="paypalId"
                  value={this.state.paypalId}
                  fullWidth={true}
                  onChange={(e) => this.onChange(e)}
                />
              </Grid>
            </Grid>

            <Grid container spacing={24}>
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <h3 style={this.styles.h3Title}>PagueSeguro</h3>
              </Grid>
              <Grid item xs={12} sm={12} md={4} lg={4}>
                <TextField
                  style={this.styles.inputs}
                  hintText="Token PagSeguro"
                  floatingLabelText="Token PagSeguro"
                  type="text"
                  name="pagSeguroToken"
                  value={this.state.pagSeguroToken}
                  fullWidth={true}
                  onChange={(e) => this.onChange(e)}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={4} lg={4}>
                <TextField
                  errorText={this.errorFormat.pagSeguroEmail}
                  style={this.styles.inputs}
                  hintText="Email PagSeguro"
                  floatingLabelText="Email PagSeguro"
                  type="email"
                  name="pagSeguroEmail"
                  value={this.state.pagSeguroEmail}
                  fullWidth={true}
                  onChange={(e) => this.onChange(e)}
                  onBlur={(e) => this.onBlurField(e)}
                />
              </Grid>
            </Grid>

            <Grid container spacing={24} style={{marginTop:20,marginBottom: 20, textAlign: 'center'}}>
              <Grid item style={{textAlign:'center'}} xs={12} sm={12} md={12} lg={12}>
                <RaisedButton
                  label="Enviar"
                  primary={true}
                  onClick={this.checkPagSeguroEmail.bind(this)}
                />
              </Grid>
            </Grid>
          </div>
        </Paper>
      </div>
    );

  }

}

export default FormsOfReceiptsForm;



/** WEBPACK FOOTER **
 ** ./src/components/Panel/FormsOfReceipts/FormsOfReceiptsForm.js
 **/